import { WorkspaceState } from '../workspace';

export const maintenanceWorkspace: WorkspaceState = {
  layout: [{ i: 'Maintenance', x: 5, y: 0, w: 20, h: 12 }],
  windows: [{ key: 'Maintenance', appName: 'Maintenance' }],
};
